import { ref, onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Occupation",
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();

    var jumpDetail = function jumpDetail() {
      router.push({
        path: "/joinUs"
      });
    };

    return {
      jumpDetail: jumpDetail
    };
  }
};